import { CheckoutStates } from 'components/DSO/DSOOrderCheckout/DSOOrderCheckout.types';
import { useRouter } from 'next/router';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { dsoCheckoutService } from 'services';

export const useDsoPlaceOrder = (
  setOrderStep: Dispatch<SetStateAction<CheckoutStates>>
) => {
  const queryClient = useQueryClient();
  const router = useRouter();
  return useMutation(
    () => {
      return dsoCheckoutService.placeOrder();
    },
    {
      onSuccess: async data => {
        const { orderNumber } = data;

        await queryClient.invalidateQueries([ServerStateKeysEnum.dsoCart]);
        await queryClient.invalidateQueries([
          ServerStateKeysEnum.dsoOrderHistory,
        ]);
        setOrderStep('complete');
        await router.push(`/dso/orderdetails/${orderNumber}`);
      },
      onError: error => {
        console.error(error);
      },
    }
  );
};
